export default __webpack_public_path__ + "static/media/lock.9c4369c8.svg";